/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountOrganizationSchema } from "../accountOrganizationSchema.ts";
import { batchResultSchema } from "../batchResultSchema.ts";
import { z } from "zod";

/**
 * @description Traitement terminé. Chaque organisation est traitée indépendamment :\nla réponse contient la liste des organisations créées/mises à jour avec succès\nainsi que la liste des organisations en erreur, sans interrompre le traitement des autres.\n
 */
export const createOrganizations200Schema = z.lazy(() => batchResultSchema).describe("Résultat du traitement d'un lot d'objets, avec succès et erreurs séparés")

/**
 * @description error occurred - see status code and problem object for more information.
 */
export const createOrganizations400Schema = z.object({
      "type": z.string().url().default("about:blank").describe("An absolute URI that identifies the problem type. When dereferenced,\nit SHOULD provide human-readable documentation for the problem type\n(e.g., using HTML).\n"),
  "title": z.string().describe("A short, summary of the problem type. Written in english and readable\nfor engineers (usually not suited for non technical stakeholders and\nnot localized); example: Service Unavailable\n").optional(),
  "status": z.number().int().min(100).max(600).describe("The HTTP status code generated by the origin server for this occurrence\nof the problem.\n").optional(),
  "detail": z.string().describe("A human readable explanation specific to this occurrence of the\nproblem.\n").optional(),
  "instance": z.string().url().describe("An absolute URI that identifies the specific occurrence of the problem.\nIt may or may not yield further information if dereferenced.\n").optional(),
  "properties": z.object({
      
      }).catchall(z.any()).describe("Additional properties that can be used to store any additional information\nabout the problem. This is useful for providing more context or details\nabout the error.\n").optional()
      })

export const createOrganizationsMutationRequestSchema = z.array(z.lazy(() => accountOrganizationSchema)).max(500)

export const createOrganizationsMutationResponseSchema = z.lazy(() => createOrganizations200Schema)